import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
import userManager from 'App/util/UserManager'
import { UserManagerEvents } from 'oidc-client'
import { useDispatch } from 'react-redux'
import { ApplicationContext } from 'App/context'
import { push } from 'connected-react-router'
import Loader from 'App/components/Loader'
import { getEnv } from 'App/util/env'
import LoadableLogo from 'App/components/LoadableLogo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons'
import Axios from 'axios'

type TEnv = {
  OIDC_SIGNIN_TYPE: string,
  SSO_CHECK_API_URL: string,
  OIDC_POPUP_WINDOW_TARGET: string

}

const env = getEnv<TEnv>({
  OIDC_SIGNIN_TYPE: process.env.REACT_APP_OIDC_SIGNIN_TYPE || 'redirect',
  SSO_CHECK_API_URL: process.env.REACT_APP_SSO_CHECK_API_URL || '',
  OIDC_POPUP_WINDOW_TARGET: process.env.REACT_APP_OIDC_POPUP_WINDOW_TARGET || '_blank'
})


export const LoginPage = () => {
  const ctx = useContext(ApplicationContext)
  const dispatch = useDispatch()

  const loginCallback: UserManagerEvents.UserLoadedCallback = () => {
    if (ctx.extraQueryParams === undefined) {
      ctx.extraQueryParams = {}
    }
    if (ctx.extraTokenParams === undefined) {
      ctx.extraTokenParams = {}
    }
    ctx.extraQueryParams.hootsuiteUserId  = window.sessionStorage.getItem('hootsuiteUserId')
    ctx.extraQueryParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp')
    ctx.extraQueryParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId')
    ctx.extraQueryParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken')
    ctx.extraQueryParams.messageId = window.sessionStorage.getItem('messageId')
    ctx.extraTokenParams.hootsuiteUserId = window.sessionStorage.getItem('hootsuiteUserId')
    ctx.extraTokenParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp')
    ctx.extraTokenParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId')
    ctx.extraTokenParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken')
    ctx.extraTokenParams.messageId = window.sessionStorage.getItem('messageId')
    window.sessionStorage.removeItem('hootsuiteUserId')
    window.sessionStorage.removeItem('hootsuiteTimestamp')
    window.sessionStorage.removeItem('hootsuitePlacementId')
    window.sessionStorage.removeItem('hootsuiteToken')
    window.sessionStorage.removeItem('messageId')
    dispatch(push('/'))
    userManager.events.removeUserLoaded(loginCallback)
  }

  React.useEffect(() => {
    if (ctx !== undefined && ctx.extraQueryParams !== undefined) {
      window.sessionStorage.setItem('hootsuiteUserId', ctx.extraQueryParams.hootsuiteUserId)
      window.sessionStorage.setItem('hootsuiteTimestamp', ctx.extraQueryParams.hootsuiteTimestamp)
      window.sessionStorage.setItem('hootsuitePlacementId', ctx.extraQueryParams.hootsuitePlacementId)
      window.sessionStorage.setItem('hootsuiteToken', ctx.extraQueryParams.hootsuiteToken)
      window.sessionStorage.setItem('messageId', ctx.extraQueryParams.messageId)
 
      if(env.OIDC_SIGNIN_TYPE === 'popup'){

        const params = {
          hootsuiteUserId: ctx.extraQueryParams.hootsuiteUserId,
          hootsuiteTimestamp: ctx.extraQueryParams.hootsuiteTimestamp,
          hootsuitePlacementId: ctx.extraQueryParams.hootsuitePlacementId,
          hootsuiteToken: ctx.extraQueryParams.hootsuiteToken,
          messageId: ctx.extraQueryParams.messageId
        }

        Axios.get(env.SSO_CHECK_API_URL, {params}).then(response => {
          const ssoTokenResponse  = response.data;
          if(ssoTokenResponse.tokenAvailable === true){
            userManager.signinRedirect({
              extraQueryParams: ctx.extraQueryParams,
              extraTokenParams: ctx.extraTokenParams
            })
          } else {
            userManager.events.addUserLoaded(loginCallback)
            const defaultPopupFeatures = 'location=no,toolbar=no,width=500,height=600,left=100,top=100;';
            const defaultPopupTarget = env.OIDC_POPUP_WINDOW_TARGET;
            userManager.createSigninRequest({
              extraQueryParams: ctx.extraQueryParams,
              extraTokenParams: ctx.extraTokenParams,
              redirect_uri: userManager.settings.popup_redirect_uri
            }).then(signinRequest => {
              window.open(signinRequest.url, defaultPopupTarget, defaultPopupFeatures);
            });


            
            /*userManager.signinPopup({
              extraQueryParams: ctx.extraQueryParams,
              extraTokenParams: ctx.extraTokenParams
            })*/
          }

        });
      } else {
        console.log('Redirecting to OIDC login: '+env.OIDC_SIGNIN_TYPE);
       /*userManager.signinRedirect({
          extraQueryParams: ctx.extraQueryParams,
          extraTokenParams: ctx.extraTokenParams
        })*/
      }
    }

  }, [])

  return (
    <>
      <Helmet title="Login" />
      {env.OIDC_SIGNIN_TYPE === 'popup' ? (
        <div className="popupInfo">
          <LoadableLogo />
          <div className="info"><span className="icon"><FontAwesomeIcon icon={faWindowRestore}/></span>Please authenticate using the popup. The popup can be blocked by the browser, if this is the case please unblock the popups for this website.</div>
          <Loader />
        </div>
      ):(
        <Loader />
      )}
    </>
  )
}

export default {
  name: 'Login',
  routeProps: {
    path: '/login',
    component: LoginPage,
  },
}
